import Navigation from "@/components/Navigation";
import ScrollProgressBar from "@/components/ScrollProgressBar";
import HeroSection from "@/components/HeroSection";
import LogoBar from "@/components/LogoBar";
import AboutSection from "@/components/AboutSection";
import AIBuilderSection from "@/components/AIBuilderSection";
import BuiltSection from "@/components/BuiltSection";
import ResultsSection from "@/components/ResultsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import ServicesSection from "@/components/ServicesSection";
import HowIWorkSection from "@/components/HowIWorkSection";
import ContactSection from "@/components/ContactSection";
import { useEffect } from "react";

const Index = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );

    document.querySelectorAll(".fade-up").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="bg-background min-h-screen">
      <ScrollProgressBar />
      <Navigation />
      <HeroSection />
      <LogoBar />
      <AboutSection />
      <AIBuilderSection />
      <BuiltSection />
      <ResultsSection />
      <TestimonialsSection />
      <ServicesSection />
      <HowIWorkSection />
      <ContactSection />
    </div>
  );
};

export default Index;
